module.exports = __webpack_public_path__ + "img/cloud-change.3029beb7.svg";